export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE'

export interface ApiEndpoint<TRequest = void, TResponse = void> {
    method: HttpMethod
    /**
     * Path relative to the environment's apis.baseUrl, e.g. 'customer/work-order/all'.
     * May contain ':paramName' tokens substituted from the request object at
     * call time (e.g. 'customer/work-order/:id').
     */
    url: string
    /** Backend permission string required for this endpoint (see routes/api/*.php ->allow:...). */
    permission?: string
    /**
     * Phantom type-only markers, never assigned a real value. Their sole
     * purpose is to make TypeScript treat ApiEndpoint<A, B> and
     * ApiEndpoint<C, D> as distinct types, so RgHttpService.call() can infer
     * the right request/response types from the endpoint const alone.
     */
    readonly _request?: TRequest
    readonly _response?: TResponse
}

/**
 * Declares a single typed API endpoint. One call site per backend route in
 * routes/api/customer-api.php / workshop-api.php -- see core/contracts/.
 */
export function endpoint<TRequest = void, TResponse = void> (
    config: { method: HttpMethod, url: string, permission?: string }
): ApiEndpoint<TRequest, TResponse> {
    return config
}
